<template>
  <page-title pageTitle="Supplier Invoice" title="New Supplier Invoice" />
  <distributor-invoices-form
    :distributorInvoice="{ distributorID: '' }"
    :submitFunction="addDistributorInvoice"
  />
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import DistributorInvoicesForm from "@/components/distributorInvoices/DistributorInvoicesForm";

export default {
  name: "NewDistributorInvoiceView",
  components: {
    PageTitle: PageTitleComponent,
    DistributorInvoicesForm: DistributorInvoicesForm,
  },
  data() {
    return {
      id: -1,
      distributorInvoices: null,
    };
  },
  methods: {
    async addDistributorInvoice(distributorInvoice) {
      await this.$store.dispatch("addDistributorInvoice", distributorInvoice);
      this.$router.push("/distributors/invoices");
    },
  },
};
</script>

<style scoped></style>
